import React, { useCallback, useMemo, useState } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { FocusRestorationContext } from '../../controllers/focus-restoration-context.tsx';

// The idea of this component is to provide a focus restoration context for the project menu items.
// The context will be read deep down the tree where the menuItem which supports drag-and-drop is rendered.

function ContentWithDragAndDropEnabled({ children }: { children: React.ReactNode }) {
	const [shouldRestoreFocus, setShouldRestoreFocus] = useState<boolean>(false);

	const enableRestoreFocus = useCallback(() => {
		setShouldRestoreFocus(true);
	}, []);

	const clearRestoreFocus = useCallback(() => {
		setShouldRestoreFocus(false);
	}, []);

	const contextValue = useMemo(
		() => ({
			shouldRestoreFocus,
			enableRestoreFocus,
			clearRestoreFocus,
		}),
		[clearRestoreFocus, enableRestoreFocus, shouldRestoreFocus],
	);

	return (
		<FocusRestorationContext.Provider value={contextValue}>
			{children}
		</FocusRestorationContext.Provider>
	);
}

export const ContentWithDragAndDrop = componentWithCondition(
	() => expVal('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
	ContentWithDragAndDropEnabled,
	({ children }: { children: React.ReactNode }) => children,
);
